import React, { useState, useEffect } from "react";
import { getTranslations } from "./i18n";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Intro from "./components/Intro";
import PrivacyGrid from "./components/PrivacyGrid";
import FeatureSection from "./components/FeatureSection";
import CallToAction from "./components/CallToAction";
import Newsletter from "./components/Newsletter";
import Changelog from "./components/Changelog";
import PrivacyPolicy from "./components/PrivacyPolicy";
import FAQ from "./components/FAQ";
import Terms from "./components/Terms";
import Footer from "./components/Footer";
import Download from "./components/Download";
import { trackPageView } from "./analytics";
import "./index.css";

// 主應用元件 - 管理語言狀態與頁面路由
const App = () => {
  const [locale, setLocale] = useState(() => {
    const saved = localStorage.getItem("vapor-lang");
    if (saved) return saved;
    const sysLang = navigator.language || navigator.userLanguage || "en";
    return sysLang.startsWith("zh") ? "zh-TW" : "en";
  });

  const getPage = (path) => {
    // 靜態資源路徑，不由 SPA 處理
    if (path.startsWith("/artifact/")) {
      return "artifact";
    }
    if (path === "/changelog") return "changelog";
    if (path === "/privacy-policy") return "privacy-policy";
    if (path === "/faq") return "faq";
    if (path === "/terms") return "terms";
    if (path === "/download") return "download";
    return "home";
  };

  const [page, setPage] = useState(() => getPage(window.location.pathname));

  const t = getTranslations(locale);

  useEffect(() => {
    localStorage.setItem("vapor-lang", locale);
    document.documentElement.lang = locale;
  }, [locale]);

  // 監聽瀏覽器前進/後退
  useEffect(() => {
    const handlePopState = () => {
      setPage(getPage(window.location.pathname));
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  // 頁面切換時立即跳到頂部（不滾動）
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [page]);

  // 路由切換時上報 GA page_view（含首次載入）
  useEffect(() => {
    trackPageView();
  }, [page]);

  // /artifact/* 路徑應由伺服器直接處理，SPA 不渲染任何內容
  if (page === "artifact") {
    return null;
  }

  // 下載頁是獨立頁面，不顯示 Navbar / Footer
  if (page === "download") {
    return (
      <div className="App">
        <Download locale={locale} />
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar t={t} locale={locale} onLocaleChange={setLocale} />
      {page === "changelog" ? (
        <>
          <Changelog />
          <Footer t={t} />
        </>
      ) : page === "privacy-policy" ? (
        <>
          <PrivacyPolicy locale={locale} />
          <Footer t={t} />
        </>
      ) : page === "faq" ? (
        <>
          <FAQ locale={locale} />
          <Footer t={t} />
        </>
      ) : page === "terms" ? (
        <>
          <Terms locale={locale} />
          <Footer t={t} />
        </>
      ) : (
        <>
          <Hero t={t} />
          <Intro t={t} />
          <FeatureSection t={t} />
          <PrivacyGrid t={t} />
          <CallToAction t={t} />
          <Newsletter t={t} />
          <Footer t={t} />
        </>
      )}
    </div>
  );
};

export default App;
